import { _defineProperty } from "@slyte/core/src/lyte-utils";
import {ZcatComponentsApp} from "./app.js";

var app = new ZcatComponentsApp({
    performance : true,
    debug : true
});

window.Lyte = app;
export {app};
